<template>
  <el-dialog
    :title="`${goods.name}`"
    :visible.sync="dialogVisible"
    width="50%">
    <div style='text-align: center;'>
      <el-image style="width: 430px; height: 430px;" :src="`${this.getaway.business}bt/goods/qrcode/${goods.id}`"></el-image>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-link type="primary" :href="`${this.getaway.business}bt/goods/qrcode/${goods.id}`" target="_blank" icon="el-icon-download" :underline="false" download>下 载</el-link>
  </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'GoodsQrCode',
  data() {
    return {
      dialogVisible: false,
      goods: ''
    }
  },
  methods: {
    open(data) {
      this.goods = data
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang='less'>

</style>